<template>
    <div>
        <card-header title="Edit Contact" icon="fa-pencil"/>

        <card-body>
            <contact-form :contact="contact"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteContact">
                        <i class="far fa-trash-alt"></i>
                        <span class="ml-2" v-if="confirmDelete">{{confirmLabel}}</span>
                    </b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" @click="submit" :disabled="!hasName">
                        <i class="fas fa-check mr-2"></i>Save Contact
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardBody from "../../TIER/components/CardBody";
    import CardFooter from "../../TIER/components/CardFooter";
    import {client as http} from "../../http_client";
    import ContactForm from "@/cards/contacts/ContactForm";

    /**
     * Edits the DIRECTORY record -- the version everywhere sees. Deleting is a
     * soft delete and the server refuses (409) while the contact is still
     * attached anywhere, so the delete button asks twice: once to confirm, and
     * again to confirm removing it from the N places it is in use.
     */
    export default {
        components: {ContactForm, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                contact: {},
                confirmDelete: false,
                inUse: 0,
                dirty: null
            };
        },
        computed: {
            hasName: function () {
                return !!((this.contact.company || '').trim() || (this.contact.name || '').trim());
            },
            confirmLabel: function () {
                return this.inUse
                    ? `Used in ${this.inUse} place${this.inUse === 1 ? '' : 's'} — delete anyway?`
                    : 'Delete Contact?';
            }
        },
        methods: {
            loadContact: function () {
                this.$emit('loading', true);
                http.get('/api/contacts/' + this.props.contactId, {force: true}).then(response => {
                    this.contact = response.data;
                    this.$emit('loading', false);
                });
            },
            submit() {
                this.$emit('loading', true);
                http.put('/api/contacts/' + this.props.contactId, this.contact, {force: true}).then(() => {
                    this.$saveAlert(false);
                    this.$reloadCard('contacts');
                    this.$reloadCard('contact-type');
                    this.$reloadCard('contact-company');
                    this.$closeCard(this.card);
                }).catch(() => {
                    this.$emit('loading', false);
                });
            },
            deleteContact() {
                if (!this.confirmDelete) {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                        this.inUse = 0;
                    }, 3000);
                    return;
                }

                this.$emit('loading', true);
                // force=1 once the in-use count has been shown and the button
                // pressed again.
                const url = '/api/contacts/' + this.props.contactId + (this.inUse ? '?force=1' : '');

                http.delete(url).then(() => {
                    this.$saveAlert(false);
                    this.$reloadCard('contacts');
                    this.$reloadCard('contact-type');
                    this.$reloadCard('contact-company');
                    this.$closeCard(this.card);
                }).catch(err => {
                    this.$emit('loading', false);
                    if (err.response && err.response.status === 409) {
                        // Still attached somewhere -- say where, keep the
                        // confirm open, and let the next press force it.
                        this.inUse = err.response.data.links;
                        this.confirmDelete = true;
                        setTimeout(() => {
                            this.confirmDelete = false;
                            this.inUse = 0;
                        }, 5000);
                    }
                });
            }
        },
        watch: {
            'props.contactId': function () {
                this.dirty = null;
                this.loadContact();
            },
            'contact': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this contact? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadContact();
        }
    };
</script>
